// extracted by mini-css-extract-plugin
export var active = "_9k-7";
export var container = "_9k-0";
export var evenWidth = "_9k-4";
export var large = "_9k-5";
export var outlet = "_9k-8";
export var slide = "_9k-2";
export var small = "_9k-6";
export var tab = "_9k-3";
export var tabs = "_9k-1";